import { Eyebrow, Reveal } from "@/components/Reveal";

const About = () => (
  <section id="om-oss" className="bg-navy2 py-20 sm:py-28">
    <div className="mx-auto grid max-w-7xl items-center gap-14 px-5 sm:px-8 lg:grid-cols-2">
      <Reveal>
        <Eyebrow>Om oss</Eyebrow>
        <h2 className="mt-4 font-display text-3xl font-bold tracking-tight text-white sm:text-4xl">Om Tillvia</h2>
        <div className="mt-5 max-w-xl space-y-4 text-base leading-relaxed text-cream/70 sm:text-lg">
          <p>Tillvia hjälper företag att skapa en starkare och mer professionell närvaro online.</p>
          <p>
            Vi erbjuder webbsidor, grafisk design, logotyper, sociala medier, digital annonsering och optimering av
            Google Företagsprofiler – samlat på ett ställe.
          </p>
          <p>
            Vårt mål är att göra digital utveckling enklare och mer tillgänglig för små och växande företag. Vi
            arbetar nära våra kunder för att förstå deras verksamhet och skapa lösningar som passar deras behov.
          </p>
        </div>
        <p className="mt-7 border-l-4 border-orange pl-4 font-display text-lg font-bold text-white">
          Tillvia – Digitalt som driver företag framåt.
        </p>
      </Reveal>

      <Reveal delay={0.15}>
        <div className="relative overflow-hidden rounded-3xl bg-navy p-8 sm:p-10">
          <div aria-hidden="true" className="absolute -right-24 -top-24 h-64 w-64 rounded-full border-[40px] border-white/5" />
          <div className="relative">
            <img src="/tillvia-logo.png" alt="Tillvias logotyp" className="w-56 sm:w-64" />
            <p className="mt-6 max-w-sm font-display text-2xl font-bold leading-snug text-white">
              Design, webb och marknadsföring – med en tydlig visuell identitet.
            </p>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);

export default About;
